export default __webpack_public_path__ + "static/media/Resume0-page-001.fb8bd733.jpg";